<template>
  <div class="container white pa-0">
    <!-- menu superior -->
    <v-layout column class="menu w-100 white">
      <v-card elevation="2" tile>
        <v-layout
          align-center
          justify-space-around
          class="py-2 px-3 colorSelectedBack sizeTop"
        >
          <img
            :src="require(`@/assets/logos/usecargobranco.png`)"
            alt="pickndrive"
            style="width: auto; height: 39px"
          />
        </v-layout>
      </v-card>
    </v-layout>

    <div style="height: 48px"></div>

    <div class="text-start pa-3 pt-4">
      <span class="title font-weight-regular"
        >Contato para o caso de sinistros, manutenção ou outros:</span
      >
    </div>
    <div class="text-center pb-2">
      <!-- <v-flex class="pb-3">
        <v-btn outlined large class="checkin-text" href="tel:30030732">
          <v-icon class="checkin-text">phone</v-icon>
          <span class="font-weight-regular title pl-2">3003-0732</span>
        </v-btn>
      </v-flex> -->
      <v-flex class="pb-3">
        <v-btn outlined large class="colorBtn" @click="openChat()">
          <v-icon left>perm_phone_msg</v-icon>
          <span class="font-weight-regular title">CHAT 24HRS</span>
        </v-btn>
      </v-flex>
    </div>
    <v-flex class="text-center px-4">
      <span class="grey--text font-weight-regular body-2"
        >contato@usecargo.mobi</span
      >
    </v-flex>

    <div class="text-start px-4">
      <v-divider class="mx-3 my-4"></v-divider>
      <v-flex class="text-start px-4 pt-1">
        <span class="title font-weight-regular">Termo de Uso:</span>
      </v-flex>
      <v-flex class="text-start px-4 pt-3">
        <span class="grey--text font-weight-regular body-2"
          >Tudo o que você precisa saber antes de usar os nossos serviços. Para
          fazer o download do termo de uso, clique no botão abaixo:</span
        >
      </v-flex>
      <v-flex class="mt-3 text-center">
        <v-btn
          outlined
          large
          class="checkin-text"
          :href="url_pdf"
          download="Termo de Uso"
        >
          <v-icon left class="checkin-text">get_app</v-icon>
          <span class="font-weight-regular checkin-text title"
            >FAZER DOWNLOAD</span
          >
        </v-btn>
      </v-flex>
    </div>
  </div>
</template>

<script>
import theming from '../../mixins/theming';
import questions from '../../helpers/help.js';
import Configuration from '../../controllers/ConfigurationController';
import VehicleRequest from '../../models/VehicleRequest.js';
import UserController from '../../controllers/UserController';

export default {
  mixins: [theming],

  created() {
    this.vehicleRequest.client_id = localStorage.getItem('client_id');
    this.getConfigurations();
  },

  data() {
    return {
      perguntas: questions,
      url_pdf: '',
      configurationController: new Configuration(this.$resource),
      configurations: {},
      vehicleRequest: new VehicleRequest(),
      userController: new UserController(this.$resource),
    };
  },

  methods: {
    async openChat() {
      await this.userController.getUserData().then(res => {
        zE('webWidget', 'identify', {
          name: res.user.name + '-' + res.client.name,
          email: res.user.email,
          organization: res.client.name,
          phone: res.user.phone,
        });
      });
      this.$zendesk.zE('webWidget', 'open');
    },

    async getConfigurations() {
      this.configurations = await this.configurationController.getAll(
        this.vehicleRequest.client_id
      );
      this.configurations = configs;
      this.setUrlPdf();
    },

    setUrlPdf() {
      this.url_pdf = this.configurations.term_of_use.value;
    },
  },
};
</script>

<style scoped>
.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}
.colorSelectedBack {
  background-color: var(--secondary-color);
}
.sizeTop {
  height: 48px;
}

.bottom {
  margin-bottom: 60px;
}

.container {
  position: relative;
  height: 100vh;
}

.checkin-text {
  color: var(--secondary-color);
  text-decoration: none;
  text-transform: none;
}

.colorBtn {
  text-decoration: none;
  text-transform: none;
  color: var(--secondary-color) !important;
}
.expansion-title {
  position: relative;
  top: 40px;
  font-weight: bold;
}
</style>
